import classNames from "classnames";
import React, { useState } from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

import Button from "@atoms/Button";
import Icon from "@atoms/Icon";
import Input from "@atoms/Input";

import useCheckLocation from "@hooks/useCheckLocation";
import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function HeaderMarket() {
  const { isPC } = useCheckDevice();

  const { changeLanguage, lang } = useLanguage();
  const { openMarket, openMenu } = useLayoutStore();

  const { isDanielJohnston } = useCheckLocation();

  const [country, setCountry] = useState(lang);

  return (
    <div
      className={classNames(
        "pc:h-auto pc:max-h-dvh pc:w-96 pc:bg-white pc:pt-4 pc:p-5 fixed top-0 right-0 z-60 flex h-dvh w-full flex-col bg-white px-4 pb-4 lg:w-1/4 dark:text-white",
        isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
      )}
    >
      {!isPC && (
        <div className="tnt-gap-x grid grid-cols-8 items-center py-4">
          <Button
            as="text"
            className="col-span-1 flex"
            onClick={() => {
              openMarket(false);
              openMenu(true);
            }}
          >
            <Icon className="h-3.5 dark:text-white" name="LeftArrow" />
          </Button>
          <Button
            as="text"
            className="col-span-4 text-base!"
            onClick={() => {
              openMarket(false);
              openMenu(true);
            }}
          >
            Back
          </Button>
        </div>
      )}

      <div className="pc:py-0 flex flex-col gap-5 py-4">
        {isPC ? (
          <div className="flex justify-between">
            <span className="col-span-8">Shipping To</span>
            <Button
              as="text"
              className="pc:visible invisible"
              onClick={() => {
                localStorage.setItem("checkLocale", JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000));
                openMarket(false);
              }}
            >
              Close
            </Button>
          </div>
        ) : null}

        <span className="text-title">Shipping Location • Currency</span>
        <div className="pc:gap-2 pc:text-md flex flex-col gap-4 text-[16px]">
          <Input
            checked={country === "ko"}
            id="korea"
            label="South Korea • KRW ₩"
            name="country"
            onChange={() => {
              setCountry("ko");
            }}
            type="radio"
            value="ko"
          />
          <Input
            checked={country === "en"}
            id="world"
            label="Rest of the World • USD $"
            name="country"
            onChange={() => {
              setCountry("en");
            }}
            type="radio"
            value="en"
          />
          <Input
            checked={country === "jp"}
            id="japan"
            label="Japan • JPY ¥"
            name="country"
            onChange={() => {
              setCountry("jp");
            }}
            type="radio"
            value="jp"
          />
        </div>
        <Button
          as="square"
          onClick={() => {
            if (country === lang) {
              localStorage.setItem("checkLocale", JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000));
              openMarket(false);
            } else {
              changeLanguage(country);
            }
          }}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}
